/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';
import type { OrgMap, NameMap, Countries, LocationMap } from '@api/org';
import type { Entries } from '@/types/general';

export type OrgData = OrgMap & NameMap & { countries: Countries } & { locationMap: Entries<LocationMap> };

export type OrgsState = Omit<OrgData, 'locationMap'> & { populated: boolean } & {
    locationMap: LocationMap;
};

const initialState: OrgsState = {
    populated: false,
    countries: [],
    companies: {},
    locations: {},
    resellers: {},
    companyLocationMap: {},
    resellerLocationMap: {},
    companyResellerMap: {},
    // todo: DON'T INCLUDE ENTIRE LOCATION MAP, components should query instead
    locationMap: {},
};

export type OrgDispatchValue = Omit<OrgData, 'countries'> & { countries?: Countries };

export const orgSlice = createSlice({
    name: 'orgs',
    initialState,
    reducers: {
        populate: (state, { payload }: PayloadAction<OrgDispatchValue>) => {
            state.populated = true;
            if (payload.countries) state.countries = payload.countries;
            state.companies = payload.companies;
            state.resellers = payload.resellers;
            state.locations = payload.locations;
            state.companyLocationMap = payload.companyLocationMap;
            state.companyResellerMap = payload.companyResellerMap;
            state.resellerLocationMap = payload.resellerLocationMap;
            state.locationMap = Object.fromEntries(payload.locationMap);
        },
        reset: () => initialState,
    },
});

export const { populate, reset } = orgSlice.actions;
export default orgSlice.reducer;
